<template>
  <div class="itemContainer">
    <h3>硬件买断模式项目回报测算</h3>
    <el-row :gutter="12" class="row-box">
      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l els">昌恩项目售价</p>

            <el-button
              v-if="showBtn_Annual"
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="baseItemHVACBO_CE_SellingPrice"
            ></el-button>
            <div v-else class="df-normal">
              <el-button
                type="info"
                icon="el-icon-close"
                circle
                size="mini"
                @click="cancel"
              ></el-button>
              <el-button
                type="success"
                icon="el-icon-check"
                circle
                size="mini"
                @click="confirm"
              ></el-button>
            </div>
          </div>

          <div class="t-a-l">
            <div class="df-ac-jsb hvacemc_bsm_cebsp">
              <el-col :span="6" class="">
                <p class="font14 els">总额：</p>
              </el-col>

              <el-col :span="8">
                <el-input class="" v-model="HVACBO_CE_SellingPrice">
                  <template slot="append">￥</template></el-input
                >
              </el-col>
            </div>

            <div class="df-ac-jsb hvacemc_bsm_cebsp">
              <el-col :span="6" class="">
                <p class="font14 els">首款比例<i class="red">*</i></p>
              </el-col>
              <el-col :span="8">
                <el-input
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  ref="btnHVACBO_CE_SellingPrice_Phase_1_P"
                  v-model="HVACBO_CE_SellingPrice_Phase_1_P"
                  :disabled="showBtn_Annual"
                >
                  <template slot="append">%</template>
                </el-input>
              </el-col>

              <el-col :span="8">
                <el-input readonly v-model="HVACBO_CE_SellingPrice_Phase_1">
                  <template slot="append">￥</template>
                </el-input>
              </el-col>
            </div>

            <div class="df-ac-jsb hvacemc_bsm_cebsp">
              <el-col :span="6" class="">
                <p class="font14 els">二款比例<i class="red">*</i></p>
              </el-col>
              <el-col :span="8">
                <el-input
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  v-model="HVACBO_CE_SellingPrice_Phase_2_P"
                  :disabled="showBtn_Annual"
                >
                  <template slot="append">%</template>
                </el-input>
              </el-col>

              <el-col :span="8">
                <el-input readonly v-model="HVACBO_CE_SellingPrice_Phase_2">
                  <template slot="append">￥</template>
                </el-input>
              </el-col>
            </div>

            <div class="df-ac-jsb hvacemc_bsm_cebsp">
              <el-col :span="6" class="">
                <p class="font14 els">三款比例</p>
              </el-col>
              <el-col :span="8">
                <el-input
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  v-model="HVACBO_CE_SellingPrice_Phase_3_P"
                  :disabled="showBtn_Annual"
                >
                  <template slot="append">%</template>
                </el-input>
              </el-col>

              <el-col :span="8">
                <el-input readonly v-model="HVACBO_CE_SellingPrice_Phase_3">
                  <template slot="append">￥</template>
                </el-input>
              </el-col>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="4">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l els mg-t-6">昌恩运维收入</p>
          </div>

          <div class="df-ac-jsb hvacemc_bsm_cebsp salesPackage">
            <el-col :span="9" class="">
              <p class="font14 t-a-l">年均：</p>
            </el-col>
            <el-col :span="15">
              <el-input readonly v-model="HVACBO_CE_OMI_Annual">
                <template slot="append">￥</template>
              </el-input>
            </el-col>
          </div>

          <div class="df-ac-jsb hvacemc_bsm_cebsp salesPackage">
            <el-col :span="9" class="">
              <p class="font14 t-a-l">6年总额：</p>
            </el-col>
            <el-col :span="15">
              <el-input readonly v-model="HVACBO_CE_OMI_Annual_Total">
                <template slot="append">￥</template>
              </el-input>
            </el-col>
          </div>
        </el-card>
      </el-col>

      <el-col :span="5">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l els mg-t-6">昌恩项目销售提成</p>
          </div>

          <div class="t-a-l">
            <div class="df-ac-jsb hvacemc_bsm_cebsp">
              <el-col :span="9" class="">
                <p class="font14 els">销售包：</p>
              </el-col>
              <el-col :span="7">
                <el-input v-model="HVACBO_Commission_P_Sales" readonly>
                  <template slot="append">%</template>
                </el-input>
              </el-col>

              <el-col :span="8">
                <el-input readonly v-model="HVACBO_Commission_Sales_Total">
                  <template slot="append">￥</template>
                </el-input>
              </el-col>
            </div>

            <div class="df-ac-jsb hvacemc_bsm_cebsp">
              <el-col :span="9" class="">
                <p class="font14 els">支持包：</p>
              </el-col>
              <el-col :span="7">
                <el-input v-model="HVACBO_Commission_P_Supports" readonly>
                  <template slot="append">%</template>
                </el-input>
              </el-col>

              <el-col :span="8">
                <el-input readonly v-model="HVACBO_Commission_Supports_Total">
                  <template slot="append">￥</template>
                </el-input>
              </el-col>
            </div>

            <div class="df-ac-jsb hvacemc_bsm_cebsp">
              <el-col :span="9" class="">
                <p class="font14 els">总提成：</p>
              </el-col>
              <el-col :span="7">
                <el-input v-model="HVACBO_Commission_P_Total" readonly>
                  <template slot="append">%</template>
                </el-input>
              </el-col>

              <el-col :span="8">
                <el-input readonly v-model="HVACBO_Commission_Total_Total">
                  <template slot="append">￥</template>
                </el-input>
              </el-col>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="5" class="">
        <div class="flex-direction-column">
          <el-card class="mg-b-10" style="height: 125px">
            <div slot="header" class="df-ac-jsb clearfix">
              <p class="t-a-l els mg-t-6">昌恩合同总营收</p>
            </div>

            <div class="df-ac-jsb">
              <el-col :span="24">
                <el-input
                  readonly
                  class="totalContractRevenue"
                  v-model="HVACBO_CE_Revenue_Total"
                >
                  <template slot="append">￥</template>
                </el-input>
              </el-col>
            </div>
          </el-card>

          <el-card class="" style="height: 125px">
            <div slot="header" class="df-ac-jsb clearfix">
              <p class="t-a-l els mg-t-6">昌恩项目提成前总毛利</p>
            </div>

            <div class="df-ac-jsb">
              <el-col :span="24">
                <el-input
                  readonly
                  class="totalContractRevenue"
                  v-model="HVACBO_CE_GrossProfitBC_Total"
                >
                  <template slot="append">￥</template>
                </el-input>
              </el-col>
            </div>
          </el-card>
        </div>
      </el-col>

      <el-col :span="4">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l els mg-t-6">昌恩项目实际总毛利</p>
          </div>
          <el-col :span="24" class="mg-t-30">
            <p class="t-a-c">
              <span style="color: gray">￥</span
              >{{ HVACBO_CE_GrossProfit_Total }}
            </p>
          </el-col>
          <el-col :span="24" class="mg-t-10">
            <p class="t-a-c">({{ HVACBO_CE_GrossProfit_Margin + '%' }})</p>
          </el-col>
        </el-card>
      </el-col>
    </el-row>

    <!-- 第二行 -->
    <el-row :gutter="12" class="row-box mg-t-10">
      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l els">代理方项目售价</p>

            <el-button
              v-if="showBtn_Agent"
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="hardwareHVACBO_Agent_SellingPrice_Phase_1_P"
            ></el-button>
            <div v-else class="df-normal">
              <el-button
                type="info"
                icon="el-icon-close"
                circle
                size="mini"
                @click="cancel_Agent"
              ></el-button>
              <el-button
                type="success"
                icon="el-icon-check"
                circle
                size="mini"
                @click="confirm_Agent"
              ></el-button>
            </div>
          </div>

          <div class="t-a-l">
            <div class="df-ac-jsb hvacemc_bsm_cebsp">
              <el-col :span="6" class="">
                <p class="font14 els">总额：</p>
              </el-col>

              <el-col :span="8">
                <el-input
                  class="totalPrice"
                  v-model="HVACBO_Agent_SellingPrice"
                >
                  <template slot="append">￥</template>
                </el-input>
              </el-col>
            </div>

            <!-- <br /> -->
            <div class="df-ac-jsb hvacemc_bsm_cebsp">
              <el-col :span="6" class="">
                <p class="font14 els">首款比例<i class="red">*</i></p>
              </el-col>
              <el-col :span="8">
                <el-input
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  ref="btnHVACBO_Agent_SellingPrice_Phase_1_P"
                  v-model="HVACBO_Agent_SellingPrice_Phase_1_P"
                  :disabled="showBtn_Agent"
                >
                  <template slot="append">%</template>
                </el-input>
              </el-col>

              <el-col :span="8">
                <el-input readonly v-model="HVACBO_Agent_SellingPrice_Phase_1">
                  <template slot="append">￥</template>
                </el-input>
              </el-col>
            </div>

            <div class="df-ac-jsb hvacemc_bsm_cebsp">
              <el-col :span="6" class="">
                <p class="font14 els">二款比例<i class="red">*</i></p>
              </el-col>
              <el-col :span="8">
                <el-input
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  v-model="HVACBO_Agent_SellingPrice_Phase_2_P"
                  :disabled="showBtn_Agent"
                >
                  <template slot="append">%</template>
                </el-input>
              </el-col>

              <el-col :span="8">
                <el-input readonly v-model="HVACBO_Agent_SellingPrice_Phase_2">
                  <template slot="append">￥</template>
                </el-input>
              </el-col>
            </div>

            <div class="df-ac-jsb hvacemc_bsm_cebsp">
              <el-col :span="6" class="">
                <p class="font14 els">三款比例</p>
              </el-col>
              <el-col :span="8">
                <el-input
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  v-model="HVACBO_Agent_SellingPrice_Phase_3_P"
                  :disabled="showBtn_Annual"
                >
                  <template slot="append">%</template>
                </el-input>
              </el-col>

              <el-col :span="8">
                <el-input readonly v-model="HVACBO_Agent_SellingPrice_Phase_3">
                  <template slot="append">￥</template>
                </el-input>
              </el-col>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="4">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l els mg-t-6">代理运维收入</p>
          </div>

          <div class="df-ac-jsb hvacemc_bsm_cebsp salesPackage">
            <el-col :span="9" class="">
              <p class="font14 t-a-l">年均：</p>
            </el-col>
            <el-col :span="15">
              <el-input readonly v-model="HVACBO_Agent_OMI_Annual">
                <template slot="append">￥</template>
              </el-input>
            </el-col>
          </div>

          <div class="df-ac-jsb hvacemc_bsm_cebsp salesPackage">
            <el-col :span="9" class="">
              <p class="font14 t-a-l">6年总额：</p>
            </el-col>
            <el-col :span="15">
              <el-input readonly v-model="HVACBO_Agent_OMI_Annual_Total">
                <template slot="append">￥</template>
              </el-input>
            </el-col>
          </div>

          <br />
          <br />

          <el-col :span="24">
            <div class="font12">**根据项目用电量与运维服务包计算</div>
          </el-col>
        </el-card>
      </el-col>

      <el-col :span="4">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l els mg-t-6">代理方项目总营收</p>
          </div>

          <div class="df-ac-jsb hvacemc_bsm_cebsp salesPackage">
            <el-col :span="24">
              <p class="pd-tb10 t-a-l">
                <span class="gray">￥</span>{{ HVACBO_Agent_Revenue_Total }}
              </p>
            </el-col>
          </div>

          <div class="">
            <el-col :span="24" class="">
              <p class="font14 t-a-l pd-tb20">代理方总毛利</p>
            </el-col>
            <el-col :span="24">
              <!-- <el-input readonly v-model="HVACBO_Agent_GrossProfit_Total">
              </el-input> -->
              <p class="pd-tb10 t-a-l">
                {{ HVACBO_Agent_GrossProfit_Total }} ({{
                  HVACBO_Agent_GrossProfit_Margin + '%'
                }})
              </p>
            </el-col>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l els mg-t-6">甲方项目节能年均收益预测</p>
          </div>

          <div class="t-a-l">
            <div class="df-ac-jsb">
              <el-col :span="8" class="">
                <p class="font14 els">昌恩直售收益：</p>
              </el-col>

              <el-col :span="7">
                <el-input class="pd0" v-model="HVACBO_Owner_Savings_Annual_CE">
                  <template slot="prepend">￥</template>
                </el-input>
              </el-col>

              <el-col :span="6">
                <p class="font14 els">回本时限：</p>
              </el-col>

              <el-col :span="5">
                <el-input class="pd0" readonly v-model="HVACBO_Owner_CE_BEP">
                  <template slot="append">年</template>
                </el-input>
              </el-col>
            </div>

            <div class="df-ac-jsb">
              <el-col :span="8" class="">
                <p class="font14 els">代理销售收益：</p>
              </el-col>

              <el-col :span="7">
                <el-input
                  class="pd0"
                  v-model="HVACBO_Owner_Savings_Annual_Agent"
                >
                  <template slot="prepend">￥</template>
                </el-input>
              </el-col>

              <el-col :span="6">
                <p class="font14 els">回本时限：</p>
              </el-col>

              <el-col :span="5">
                <el-input class="pd0" readonly v-model="HVACBO_Owner_Agent_BEP">
                  <template slot="append">年</template>
                </el-input>
              </el-col>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="4">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l els mg-t-6">甲方项目节能6年实际毛收益</p>
          </div>

          <div class="t-a-l">
            <div class="df-ac-jsb">
              <el-col :span="14" class="">
                <p class="font14 els">昌恩直售实际收益</p>
              </el-col>

              <el-col :span="10">
                <el-input class="pd0" v-model="HVACBO_Owner_Savings_Total">
                  <template slot="prepend">￥</template>
                </el-input>
              </el-col>
            </div>
          </div>

          <div class="t-a-l">
            <div class="df-ac-jsb">
              <el-col :span="14" class="">
                <p class="font14 els">代理销售实际收益</p>
              </el-col>

              <el-col :span="10">
                <el-input class="pd0" v-model="HVACBO_Owner_Savings_Total">
                  <template slot="prepend">￥</template>
                </el-input>
              </el-col>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { symbolOfRMB } from '@/utils/symbolOfRMB'
export default {
  props: ['metadata'],
  data () {
    return {
      // 昌恩项目售价
      HVACBO_CE_SellingPrice: '',
      HVACBO_CE_SellingPrice_Phase_1_P: '',
      HVACBO_CE_SellingPrice_Phase_2_P: '',
      HVACBO_CE_SellingPrice_Phase_3_P: '',
      HVACBO_CE_SellingPrice_Phase_1: '',
      HVACBO_CE_SellingPrice_Phase_2: '',
      HVACBO_CE_SellingPrice_Phase_3: '',

      orginContent_HVACBO_CE_SellingPrice_Phase_1_P: '',
      orginContent_HVACBO_CE_SellingPrice_Phase_2_P: '',
      orginContent_HVACBO_CE_SellingPrice_Phase_3_P: '',

      // 昌恩运维收入
      HVACBO_CE_OMI_Annual: '',
      HVACBO_CE_OMI_Annual_Total: '',

      // 昌恩项目销售提成
      HVACBO_Commission_P_Sales: '0',
      HVACBO_Commission_P_Supports: '0',
      HVACBO_Commission_P_Total: '0',

      HVACBO_Commission_Sales_Total: '0',
      HVACBO_Commission_Supports_Total: '0',
      HVACBO_Commission_Total_Total: '0',

      // 昌恩合同总营收
      HVACBO_CE_Revenue_Total: '0',
      // 昌恩项目提成前总毛利
      HVACBO_CE_GrossProfitBC_Total: '0',
      // 昌恩项目实际总毛利
      HVACBO_CE_GrossProfit_Total: '0',
      HVACBO_CE_GrossProfit_Margin: '0',

      // 代理方项目售价
      HVACBO_Agent_SellingPrice: '',
      HVACBO_Agent_SellingPrice_Phase_1_P: '',
      HVACBO_Agent_SellingPrice_Phase_2_P: '',
      HVACBO_Agent_SellingPrice_Phase_3_P: '',
      HVACBO_Agent_SellingPrice_Phase_1: '',
      HVACBO_Agent_SellingPrice_Phase_2: '',
      HVACBO_Agent_SellingPrice_Phase_3: '',

      orginContent_HVACBO_Agent_SellingPrice_Phase_1_P: '',
      orginContent_HVACBO_Agent_SellingPrice_Phase_2_P: '',
      orginContent_HVACBO_Agent_SellingPrice_Phase_3_P: '',

      // 代理运维收入
      HVACBO_Agent_OMI_Annual: '',
      HVACBO_Agent_OMI_Annual_Total: '',

      // 代理方项目总营收
      HVACBO_Agent_Revenue_Total: '',
      // 代理方项目总毛利
      HVACBO_Agent_GrossProfit_Total: '',
      HVACBO_Agent_GrossProfit_Margin: '',
      // 甲方项目节能年均收益预测
      HVACBO_Owner_Savings_Annual_CE: '',
      HVACBO_Owner_CE_BEP: '',
      HVACBO_Owner_Savings_Annual_Agent: '',
      HVACBO_Owner_Agent_BEP: '',
      // 甲方项目节能6年实际毛收益
      HVACBO_Owner_Savings_Total: '',
      //---

      showBtn_Annual: true,
      showBtn_Agent: true
    }
  },
  watch: {
    metadata: {
      handler (newval) {
        this.dumpData(newval)
      },
      immediate: true
    }
  },
  mounted () {},
  computed: {
    //年均节电量（度）
    annualElectricitySaving () {
      const res =
        this.modelOfContractForm.annualElectricityConsumption *
        this.modelOfContractForm.annualEnergySavingRate
      return res.toFixed(2)
    },
    // 月均节电量（度）
    averageMonthlyElectricitySaving () {
      const res = this.annualElectricitySaving / 12
      return res.toFixed(2)
    },
    // 项目年均总节电费
    totalAnnualElectricitySavings () {
      const res =
        this.annualElectricitySaving *
        this.modelOfContractForm.electricityBillPrice
      // 使用正则表达式添加千位分隔符
      const formattedAmount = res
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')

      return formattedAmount
    }
  },
  methods: {
    //回显数据
    dumpData (data) {
      // 昌恩项目售价symbolOfRMB
      this.HVACBO_CE_SellingPrice = symbolOfRMB(data.HVACBO_CE_SellingPrice) //总额
      this.HVACBO_CE_SellingPrice_Phase_1_P = (
        data.HVACBO_CE_SellingPrice_Phase_1_P * 100
      ).toFixed(1)
      this.HVACBO_CE_SellingPrice_Phase_2_P = (
        data.HVACBO_CE_SellingPrice_Phase_2_P * 100
      ).toFixed(1)

      this.HVACBO_CE_SellingPrice_Phase_3_P = (
        data.HVACBO_CE_SellingPrice_Phase_3_P * 100
      ).toFixed(1)

      this.HVACBO_CE_SellingPrice_Phase_1 = symbolOfRMB(
        data.HVACBO_CE_SellingPrice_Phase_1
      )
      this.HVACBO_CE_SellingPrice_Phase_2 = symbolOfRMB(
        data.HVACBO_CE_SellingPrice_Phase_2
      )
      this.HVACBO_CE_SellingPrice_Phase_3 = symbolOfRMB(
        data.HVACBO_CE_SellingPrice_Phase_3
      )

      this.orginContent_HVACBO_CE_SellingPrice_Phase_1_P = symbolOfRMB(
        data.orginContent_HVACBO_CE_SellingPrice_Phase_1_P
      )

      this.orginContent_HVACBO_CE_SellingPrice_Phase_2_P = symbolOfRMB(
        data.orginContent_HVACBO_CE_SellingPrice_Phase_2_P
      )

      this.orginContent_HVACBO_CE_SellingPrice_Phase_3_P = symbolOfRMB(
        data.orginContent_HVACBO_CE_SellingPrice_Phase_3_P
      )

      // 昌恩运维收入
      this.HVACBO_CE_OMI_Annual = symbolOfRMB(data.HVACBO_CE_OMI_Annual)
      this.HVACBO_CE_OMI_Annual_Total = symbolOfRMB(
        data.HVACBO_CE_OMI_Annual_Total
      )
      console.log('6年总额', this.HVACBO_CE_OMI_Annual_Total)

      // 昌恩项目销售提成
      this.HVACBO_Commission_P_Sales = (
        data.HVACBO_Commission_P_Sales * 100
      ).toFixed(2)
      this.HVACBO_Commission_P_Supports = (
        data.HVACBO_Commission_P_Supports * 100
      ).toFixed(2)
      this.HVACBO_Commission_P_Total = (
        data.HVACBO_Commission_P_Total * 100
      ).toFixed(2)

      this.HVACBO_Commission_Sales_Total = symbolOfRMB(
        data.HVACBO_Commission_Sales_Total
      )
      this.HVACBO_Commission_Supports_Total = symbolOfRMB(
        data.HVACBO_Commission_Supports_Total
      )

      this.HVACBO_Commission_Total_Total = symbolOfRMB(
        data.HVACBO_Commission_Total_Total
      )

      // 昌恩合同总营收
      this.HVACBO_CE_Revenue_Total = symbolOfRMB(data.HVACBO_CE_Revenue_Total)
      // 昌恩项目提成前总毛利
      this.HVACBO_CE_GrossProfitBC_Total = symbolOfRMB(
        data.HVACBO_CE_GrossProfitBC_Total
      )
      // 昌恩项目实际总毛利
      this.HVACBO_CE_GrossProfit_Total = symbolOfRMB(
        data.HVACBO_CE_GrossProfit_Total
      )
      this.HVACBO_CE_GrossProfit_Margin = (
        data.HVACBO_CE_GrossProfit_Margin * 100
      ).toFixed(2)

      // 代理方项目售价
      this.HVACBO_Agent_SellingPrice = symbolOfRMB(
        data.HVACBO_Agent_SellingPrice
      )
      this.HVACBO_Agent_SellingPrice_Phase_1_P = (
        data.HVACBO_Agent_SellingPrice_Phase_1_P * 100
      ).toFixed(1)

      this.HVACBO_Agent_SellingPrice_Phase_2_P = (
        data.HVACBO_Agent_SellingPrice_Phase_2_P * 100
      ).toFixed(1)
      this.HVACBO_Agent_SellingPrice_Phase_3_P = (
        data.HVACBO_Agent_SellingPrice_Phase_3_P * 100
      ).toFixed(1)

      this.HVACBO_Agent_SellingPrice_Phase_1 = symbolOfRMB(
        data.HVACBO_Agent_SellingPrice_Phase_1
      )

      this.HVACBO_Agent_SellingPrice_Phase_2 = symbolOfRMB(
        data.HVACBO_Agent_SellingPrice_Phase_2
      )

      this.HVACBO_Agent_SellingPrice_Phase_3 = symbolOfRMB(
        data.HVACBO_Agent_SellingPrice_Phase_3
      )

      this.orginContent_HVACBO_Agent_SellingPrice_Phase_1_P =
        data.orginContent_HVACBO_Agent_SellingPrice_Phase_1_P
      this.orginContent_HVACBO_Agent_SellingPrice_Phase_2_P =
        data.orginContent_HVACBO_Agent_SellingPrice_Phase_2_P
      this.orginContent_HVACBO_Agent_SellingPrice_Phase_3_P =
        data.orginContent_HVACBO_Agent_SellingPrice_Phase_3_P

      // 代理运维收入
      this.HVACBO_Agent_OMI_Annual = symbolOfRMB(data.HVACBO_Agent_OMI_Annual)
      this.HVACBO_Agent_OMI_Annual_Total = symbolOfRMB(
        data.HVACBO_Agent_OMI_Annual_Total
      )
      // 代理方项目总营收
      this.HVACBO_Agent_Revenue_Total = symbolOfRMB(
        data.HVACBO_Agent_Revenue_Total
      )
      // 代理方项目总毛利
      this.HVACBO_Agent_GrossProfit_Total = symbolOfRMB(
        data.HVACBO_Agent_GrossProfit_Total
      )

      this.HVACBO_Agent_GrossProfit_Margin = (
        data.HVACBO_Agent_GrossProfit_Margin * 100
      ).toFixed(2)

      // 甲方项目节能年均收益预测
      this.HVACBO_Owner_Savings_Annual_CE = symbolOfRMB(
        data.HVACBO_Owner_Savings_Annual_CE
      )
      this.HVACBO_Owner_CE_BEP = data.HVACBO_Owner_CE_BEP

      this.HVACBO_Owner_Savings_Annual_Agent = symbolOfRMB(
        data.HVACBO_Owner_Savings_Annual_Agent
      )

      this.HVACBO_Owner_Agent_BEP = data.HVACBO_Owner_Agent_BEP
      // 甲方项目节能6年实际毛收益
      this.HVACBO_Owner_Savings_Total = symbolOfRMB(
        data.HVACBO_Owner_Savings_Total
      )
    },

    baseItemHVACBO_CE_SellingPrice () {
      this.showBtn_Annual = false
      this.$nextTick(() => {
        this.$refs.btnHVACBO_CE_SellingPrice_Phase_1_P.focus()
      })
    },
    cancel () {
      this.showBtn_Annual = true
      // this.HVAC_EnergyConsumption_Annual = this.orginContent
      this.HVACBO_CE_SellingPrice_Phase_1_P =
        this.orginContent_HVACBO_CE_SellingPrice_Phase_1_P
      this.HVACBO_CE_SellingPrice_Phase_2_P =
        this.orginContent_HVACBO_CE_SellingPrice_Phase_2_P
      this.HVACBO_CE_SellingPrice_Phase_3_P =
        this.orginContent_HVACBO_CE_SellingPrice_Phase_3_P
    },
    confirm (event) {
      this.showBtn_Annual = true
      // this.orginContent = this.HVAC_EnergyConsumption_Annual
      this.orginContent_HVACBO_CE_SellingPrice_Phase_1_P =
        this.HVACBO_CE_SellingPrice_Phase_1_P
      this.orginContent_HVACBO_CE_SellingPrice_Phase_2_P =
        this.HVACBO_CE_SellingPrice_Phase_2_P
      this.orginContent_HVACBO_CE_SellingPrice_Phase_3_P =
        this.HVACBO_CE_SellingPrice_Phase_3_P
    },
    //
    hardwareHVACBO_Agent_SellingPrice_Phase_1_P () {
      this.showBtn_Agent = false
      this.$nextTick(() => {
        this.$refs.btnHVACBO_Agent_SellingPrice_Phase_1_P.focus()
      })
    },
    cancel_Agent () {
      this.showBtn_Agent = true
      // this.HVAC_EnergyConsumption_Annual = this.orginContent

      this.HVACBO_Agent_SellingPrice_Phase_1_P =
        this.orginContent_HVACBO_Agent_SellingPrice_Phase_1_P
      this.HVACBO_Agent_SellingPrice_Phase_2_P =
        this.orginContent_HVACBO_Agent_SellingPrice_Phase_2_P
      this.HVACBO_Agent_SellingPrice_Phase_3_P =
        this.orginContent_HVACBO_Agent_SellingPrice_Phase_3_P
    },
    confirm_Agent (event) {
      this.showBtn_Agent = true
      // this.orginContent = this.HVAC_EnergyConsumption_Annual
      this.orginContent_HVACBO_Agent_SellingPrice_Phase_1_P =
        this.HVACBO_Agent_SellingPrice_Phase_1_P
      this.orginContent_HVACBO_Agent_SellingPrice_Phase_2_P =
        this.HVACBO_Agent_SellingPrice_Phase_2_P
      this.orginContent_HVACBO_Agent_SellingPrice_Phase_3_P =
        this.HVACBO_Agent_SellingPrice_Phase_3_P
    }
  }
}
</script>

<style lang="less" scoped>
.itemContainer {
  // margin: 60px 0;
}

.projectSharingModeSelection {
  margin: 0;
}


h3 {
  margin: 20px;
}
.row-box {
  display: flex;
  flex-flow: wrap;
}
.row-box .el-card {
  height: 260px;
  border-radius: 8px;
}

.row-box .el-card:hover {
  box-shadow: 0 2px 12px 0 rgb(255 25 255 / 10%);
}

.row-box .box-card {
  // height: 294px;
  height: 260px;
}
::v-deep .el-form-item__label {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 32px;
  text-align: left;
}

// ::v-deep .el-input__inner {
//   margin: 0px 0;
// }
.noBorder ::v-deep .el-input__inner {
  border: none !important;
  font-weight: 700;
}
.projectOperation {
  text-align: left;
}
.el-radio-group {
  text-align: left;
}
.el-radio-group .el-radio {
  padding: 8px 0;
}

.projectSharingModeSelection ::v-deep .el-input__inner {
  margin: 8px 0 !important;
}
// .el-form-item {
//   margin: 0 !important;
// }
.redcolor ::v-deep .el-input__inner {
  color: red !important;
}
.grayColor ::v-deep .el-input__inner {
  color: gray !important;
}

.greenColor ::v-deep .el-input__inner {
  color: green !important;
}
.redcolor {
  color: red !important;
}
.grayColor {
  color: gray !important;
}

.greenColor {
  color: green !important;
}
.restFormItemMargin.el-form-item {
  margin-bottom: 0;
}
.salesCommissions {
  display: flex;
  align-items: start;
}
.salesCommissions .percentage {
  margin-top: 13px;
}
// 设置input无背景色
.noBgc ::v-deep .el-input__inner {
  background-color: transparent !important;
  color: #303133 !important;
}

// 修改默认的el-form-item  margin
.changeFormItem .el-form-item {
  margin: 12px 0 !important;
}
.changeFormItem .el-input ::v-deep .el-input__inner {
  margin: 0px 0;
}
.form1 {
  margin-top: 100px !important;
}
.changeFormItem .box {
  margin: 30px 0 !important;
}

.totalPrice::v-deep .el-input__inner {
  text-align: center;
}
// 输入框文字右对齐
.hvacemc_bsm_cebsp ::v-deep .el-input__inner {
  text-align: right;
  min-width: 60px;
  padding: 0 10px;
}
p {
  font-size: 14px;
}
.el-button {
  border: none !important;
  background-color: transparent;
  color: #303133;
}
// .salesPackage {
//   margin-top: 24px;
// }
.setTxtLeft ::v-deep .el-input__inner {
  text-align: left;
}
.pd0 ::v-deep .el-input__inner {
  padding: 0;
}

.totalContractRevenue ::v-deep .el-input__inner {
  margin-top: -8px;
}

.setLeft ::v-deep .el-input__inner {
  text-align: left;
  padding: 0;
}
.setCenter ::v-deep .el-input__inner {
  text-align: center;
  padding: 0;
}
.setRight ::v-deep .el-input__inner {
  text-align: right;
  padding: 0;
}
::v-deep .el-input-group__prepend {
  background-color: transparent;
  border: none;
  padding: 0;
}
</style>
